<template>
    <MiniCatalogueSection
        v-if="activeRecommendedContent?.length"
        title="For You"
        seeAllAriaLabel="See All Content"
        :seeAllUrl="recommendedContentUrl"
        :preLoadedContent="activeRecommendedContent"
        trackingSection="recommended"
    >
        <template v-if="tabsData.length > 0" #tabs="{ resetPagination }">
            <div class="tw-pb-[15px]">
                <FilterTabs
                    :active-tab="activeTab.value"
                    :tab-options="tabsData"
                    @onTabClick="(tab) => handleTabClick(tab, resetPagination)"
                />
            </div>
        </template>
    </MiniCatalogueSection>
</template>

<script setup>
import { ref, computed } from "vue";
import FilterTabs from "@collections/Filter/FilterTabs.vue";
import userJourney from "@services/userJourney";
import { useUserStore } from "@stores/user";
import MiniCatalogueSection from "@collections/MiniCatalogueSection/MiniCatalogueSection.vue";

const props = defineProps({
    recommendedContent: { type: Object, default: () => ({}) },
    recommendedContentUrl: { type: String, default: "", required: true },
});

const activeTab = ref({ key: "all", value: "All" });

const tabsData = computed(() => {
    return [{ value: "All", key: "all" }, ...props.recommendedContent.tabs];
});

const activeRecommendedContent = computed(() => {
    return (
        (props.recommendedContent?.data &&
            props.recommendedContent?.data[activeTab.value.key]) ||
        []
    );
});

const handleTabClick = (tab, resetPagination) => {
    activeTab.value = tab;
    setTimeout(() => {
        trackFilterGroup();
        resetPagination();
    }, 10);
};

const trackFilterGroup = () => {
    const userStore = useUserStore();

    const payload = {
        brand: userStore.brand,
        section: "home",
        group: activeTab.value.value,
        homepage_section: "recommended",
    };

    userJourney.trackFilterGroup({
        token: userStore.token,
        payload,
    });
};
</script>
